// MARCA | 09/10/2026 | Resets free gift cart lines (rendered with <free-gift-quantity-guard> by cart-item.liquid) back to quantity 1.
// MARCA | 09/10/2026 | Catches quantities raised outside the cart UI, e.g. a product page quantity selector or a /cart/add link.
if (!customElements.get("free-gift-quantity-guard")) {
  const pendingLineKeys = new Set();
  // MARCA | 09/10/2026 | Each line key is only reset once per page view, so a failed update cannot loop.
  const handledLineKeys = new Set();
  let isFlushScheduled = false;

  const getCartUpdateUrl = () => {
    const cartUpdateUrl = window.routes?.cart_update_url || "/cart/update";
    return cartUpdateUrl.endsWith(".js") ? cartUpdateUrl : `${cartUpdateUrl}.js`;
  };

  // MARCA | 09/10/2026 | Cart page re-renders via reload; elsewhere use the theme's cart drawer refresh.
  const refreshCart = () => {
    const bodyClasses = document.body.classList;
    if (bodyClasses.contains("page-type-cart") || bodyClasses.contains("template-cart")) {
      window.location.reload();
      return;
    }

    document.dispatchEvent(new CustomEvent("cart-drawer:refresh", { bubbles: true }));
    if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: "free-gift-quantity-guard" });
    }
  };

  // MARCA | 09/10/2026 | One /cart/update.js request for every over-quantity gift line, keyed by line item key.
  const flushPendingLines = async () => {
    isFlushScheduled = false;

    const updates = {};
    pendingLineKeys.forEach((lineKey) => {
      updates[lineKey] = 1;
      handledLineKeys.add(lineKey);
    });
    pendingLineKeys.clear();
    if (!Object.keys(updates).length) return;

    try {
      const response = await fetch(getCartUpdateUrl(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ updates }),
      });
      const cart = await response.json();
      const isStillOverLimit = (cart.items || []).some(
        (item) => updates[item.key] && item.quantity > 1,
      );

      if (!response.ok || isStillOverLimit) {
        console.warn("[MARCA Free Gift Quantity] Could not reset free gift quantity to 1", cart);
        return;
      }

      refreshCart();
    } catch (error) {
      console.warn("[MARCA Free Gift Quantity] Could not reset free gift quantity to 1", error);
    }
  };

  class FreeGiftQuantityGuard extends HTMLElement {
    connectedCallback() {
      const lineKey = this.dataset.lineKey;
      if (!lineKey || handledLineKeys.has(lineKey)) return;

      pendingLineKeys.add(lineKey);
      if (isFlushScheduled) return;
      isFlushScheduled = true;
      window.setTimeout(flushPendingLines, 0);
    }
  }

  customElements.define("free-gift-quantity-guard", FreeGiftQuantityGuard);
}
